import React, { useState } from 'react';
import { GlasswareSearchRequest } from '../models/glassware-search-request';
import { GlasswareType } from '../models/enums';
import { GlasswareLookupItem } from '../models/glassware-lookup-item';
import { CrudFunctions } from '../utilities/crud-functions';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';

import DataGrid, {
    Column,
    Selection,
    Paging,
    HeaderFilter,
    FilterRow,
    LoadPanel
} from 'devextreme-react/data-grid';

import {
    TextBox,
    NumberBox,
} from 'devextreme-react';
import { Button } from 'devextreme-react/button';

export interface Props {
    glasswareType?: GlasswareType;
    onApplySelection?: (glasswareItem: GlasswareLookupItem) => void;
    onCancel?: () => void;
}

export default function GlasswareSearch(props: Props) {
    const [glassware, setGlassware] =
        useState<GlasswareLookupItem[]>();

    const [selectedGlassware, setSelectedGlassware] =
        useState<GlasswareLookupItem>();

    const [glasswareIdFilter, setGlasswareIdFilter] =
        useState<string>();

    const [glasswareSizeFilter, setGlasswareSizeFilter] =
        useState<number>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    return (
        <div>
            <div className="pw-comp-row">
                <div className="pw-form-unit pw-comp-20">
                    <label className="textbox-label">Glassware ID</label>
                    <TextBox id="glasswareId" className="textbox"
                        onValueChanged={glasswareIdFilterValueChanged}
                        showClearButton={true}
                        placeholder="glassware id" value={glasswareIdFilter ? glasswareIdFilter : undefined} />
                </div>

                <div className="pw-form-unit pw-comp-20">
                    <label className="textbox-label">Size(mL)</label>
                    <NumberBox id="size" className="textbox"
                        showClearButton={true}
                        onValueChanged={glasswareSizeFilterValueChanged}
                        placeholder="size (mL)" value={glasswareSizeFilter ? glasswareSizeFilter : undefined} />
                </div>

                <Button id="searchButton" text="Search" icon="find" type="success"
                    className="pw-button-right-labeled-textbox"
                    hint="search"
                    height={'1.6rem'}
                    onClick={onSearch} />
            </div>

            <div className="pw-comp-row">
                <DataGrid
                    height={"29rem"}
                    dataSource={glassware ? glassware : []}
                    onSelectionChanged={glasswareSelectionChanged}
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Selection mode={'single'} />
                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />
                    <Paging enabled={false} />

                    <Column dataField={'name'} width='40%' />
                    <Column dataField={'description'} width='60%' />

                </DataGrid>
            </div>

            <div className="pw-comp-row">
                <div className="pw-centered-buttons-container">
                    <Button id="applySelectionButton"
                        className="pw-button"
                        text="Apply" type="success"
                        hint="apply selection"
                        height={'2.6em'}
                        onClick={onApplyClick} />

                    <Button id="cancelButton"
                        className="pw-button"
                        text="Cancel" type="normal"
                        hint="cancel"
                        height={'2.6em'}
                        onClick={onCancelClick} />
                </div>
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    function glasswareIdFilterValueChanged(e: any) {
        setGlasswareIdFilter(e.value);
    }

    function glasswareSizeFilterValueChanged(e: any) {
        setGlasswareSizeFilter(e.value);
    }

    function onApplyClick(e: any) {
        if (selectedGlassware && props.onApplySelection)
            props.onApplySelection(selectedGlassware);
    }

    function onCancelClick(e: any) {
        if (props.onCancel)
            props.onCancel();
    }

    function glasswareSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
           setSelectedGlassware(e.selectedRowsData[0]);
        }
    }

    function onSearch(e: any) {
        let request: GlasswareSearchRequest = {
            glasswareId: glasswareIdFilter,
            glasswareSize: glasswareSizeFilter,
            glasswareType: props.glasswareType
        }

        getGlassware(request);
    }

    async function getGlassware(request: GlasswareSearchRequest) {
        await CrudFunctions.postData("common/glasswaresearch", request)
            .then((data) => {
                setGlassware(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Glassware");
            });
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}

